import { createRouter, createWebHistory } from 'vue-router';
import { useAuthStore } from '@/stores/authStore';

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/components/LoginView.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/panel',
    name: 'Panel',
    component: () => import('@/components/DashboardPanel.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/test-agora',
    name: 'TestAgora',
    component: () => import('@/components/Actions_Agora.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/',
    redirect: '/panel'
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

router.beforeEach(async (to, from, next) => {
  const authStore = useAuthStore();
  
  // Verificar si hay un token en los parámetros de la URL
  const urlToken = to.query.token || to.params.token;
  
  if (urlToken) {
    // Si hay un token en la URL, intentar autenticar con él
    try {
      // Recopilar todos los parámetros de la URL
      const allParams = { ...to.query, ...to.params };
      await authStore.checkAndUpdateTokenFromUrl(allParams);
      
      // Si la autenticación fue exitosa y estamos en login, redirigir a panel
      if (to.path === '/login') {
        next({
          path: '/panel',
          query: { 
            ticket_global_id: allParams.ticket_global_id,
            ticket_id: allParams.ticket_id,
            user: allParams.user,
            pos: allParams.pos
          }
        });
        return;
      }
    } catch (error) {
      console.error('Error autenticando con token de URL:', error);
      // Si falla la autenticación con el token, continuar con el flujo normal
    }
  }
  
  // Flujo normal de autenticación
  if (to.meta.requiresAuth && !authStore.isAuthenticated) {
    next('/login');
  } else if (to.path === '/login' && authStore.isAuthenticated) {
    next({
      path: '/panel',
      query: to.query,
      hash: to.hash
    });
  } else {
    next();
  }
});

export default router;